import { render, staticRenderFns } from "./PH1V_S30.vue?vue&type=template&id=dac165d2&scoped=true"
import script from "./PH1V_S30.vue?vue&type=script&lang=js"
export * from "./PH1V_S30.vue?vue&type=script&lang=js"
import style0 from "./PH1V_S30.vue?vue&type=style&index=0&id=dac165d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac165d2",
  null
  
)

export default component.exports